<template>
    <div>
        <label id="listbox-label" class="sr-only"> Change published status </label>
        <div class="relative">
            <div class="inline-flex w-full rounded-md divide-brand-600 divide-x">
                <div class="relative z-0 inline-flex w-full rounded-md divide-brand-600 divide-x">
                    <div @click="showOptions = !showOptions" :class="[showOptions ? 'bg-brand-600' : 'bg-brand-500']" class="relative inline-flex items-center pl-3 pr-4 py-3 w-full text-white rounded-l-md cursor-pointer">
                        <!-- Heroicon name: solid/check -->
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <p class="ml-2.5 text-sm font-semibold tracking-wide uppercase truncate">{{ participantOption }}</p>
                    </div>
                    <button
                        :disabled="!hasOptions"
                        @click="showOptions = !showOptions"
                        type="button"
                        :class="[showOptions ? 'ring-offset-2 ring-offset-gray-50 ring-brand-500 outline-none z-10 ring-2 bg-brand-400' : 'bg-brand-500']"
                        class="relative focus:z-10 inline-flex items-center px-3 py-2 text-white text-sm font-medium hover:bg-brand-600 rounded-r-md focus:outline-none blur:ring-0 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-gray-50 transition"
                        aria-haspopup="listbox"
                        aria-expanded="true"
                        aria-labelledby="listbox-label"
                    >
                        <span class="sr-only">Change participant option</span>
                        <!-- Heroicon name: solid/chevron-down -->
                        <svg v-if="hasOptions" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
                </div>
            </div>

            <div v-if="hasOptions" v-show="showOptions">
                <ul
                    class="absolute z-50 left-0 right-0 mt-2 mx-0 bg-white rounded-lg focus:outline-none shadow-lg divide-gray-200 divide-y overflow-hidden origin-top-right ring-1 ring-black ring-opacity-10 xl:mx-0"
                    tabindex="-1"
                    role="listbox"
                    aria-labelledby="listbox-label"
                    aria-activedescendant="listbox-option-0"
                >
                    <li class="px-4 py-2">
                        <p class="text-center text-gray-900 text-xs font-medium uppercase">Who are you challenging?</p>
                    </li>
                    <li @click="changeOption('targeted')" class="group relative p-4 hover:bg-brand-500 transition cursor-pointer select-none" id="listbox-option-0" role="option">
                        <div class="flex flex-col">
                            <div class="flex">
                                <span v-show="value === 'targeted'" class="mr-1" :class="[value === 'targeted' ? 'text-brand-700 group-hover:text-white' : 'text-gray-900']">
                                    <!-- Heroicon name: solid/check -->
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                </span>
                                <p :class="[value === 'targeted' ? 'text-brand-700 font-medium' : 'text-gray-700']" class="group-hover:text-white text-sm group-hover:font-medium uppercase">Challenging Someone Else</p>
                            </div>
                            <p class="mt-2 text-gray-500 group-hover:text-white text-xs">This challenge can only be completed by the person I choose.</p>
                        </div>
                    </li>

                    <li v-if="hasOptions" @click="changeOption('personal')" class="group relative p-4 hover:bg-brand-500 cursor-pointer select-none" id="listbox-option-1" role="option">
                        <div class="flex flex-col">
                            <div class="flex">
                                <span v-show="value === 'personal'" class="mr-1" :class="[value === 'personal' ? 'text-brand-700 group-hover:text-white' : 'text-gray-900']">
                                    <!-- Heroicon name: solid/check -->
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                </span>
                                <p :class="[value === 'personal' ? 'text-brand-700 font-medium' : 'text-gray-700']" class="group-hover:text-white text-sm group-hover:font-medium uppercase">Challenging Myself</p>
                            </div>
                            <p class="mt-2 text-gray-500 group-hover:text-white text-xs">This challenge will only be completed by me.</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div v-show="showOptions" class="fixed z-40 inset-0" @click="showOptions = false"></div>
    </div>
</template>

<script>
export default {
    props: ["value"],
    watch: {
        value() {
            this.showOptions = false
        },
    },
    computed: {
        participantOption() {
            if (this.value === "targeted") {
                return "Challenging someone else"
            }

            if (this.value === "personal") {
                return "Challenging myself"
            }

            return "Challenging @" + this.value
        },

        hasOptions() {
            if (this.value === "targeted") {
                return true
            }

            return this.value === "personal"
        },
    },
    data() {
        return {
            showOptions: false,
        }
    },

    methods: {
        changeOption(val) {
            this.$emit("input", val)
        },
    },
}
</script>
